<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      title: "",
      description: "",
      description2: "",
    };
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: "description", name: "description", content: this.description },
        {
          vmid: "keywords",
          name: "keywords",
          content: this.description2,
        },
      ],
    };
  },
  created() {
    //1是关键字 2标题 3描述
    this.getkeys();
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    // 获取关键字标题和描述
    async getkeys() {
      let i;
      for (i = 1; i < 4; i++) {
        await this.$service.home
          .getkeys({ status: i })
          .then((res) => {
            if (res.data.code == 200) {
              if (i == 1) {
                let arr = [];
                res.data.content.map((item) => {
                  arr.push(item.name);
                  this.description = arr.join(",");
                });
                document
                  .querySelector('meta[name="keywords"]')
                  .setAttribute("content", this.description);
              }
              if (i == 2) {
                this.title = res.data.content[0].name;
              }
              if (i == 3) {
                let arr = [];
                res.data.content.map((item) => {
                  arr.push(item.name);
                  this.description2 = arr.join(",");
                  document
                    .querySelector('meta[name="description"]')
                    .setAttribute("content", this.description2);
                });
              }
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
  },
};
</script>

<style lang="less">
body {
  margin: 0;
  padding: 0;
  background-color: #f9f9f9;
}
#app {
  min-width: 1440px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  letter-spacing: 1px;
  cursor: pointer;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
}
.background {
  background-color: #f9f9f9;
  margin: 0 auto;
}
.new_d {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  > span:nth-child(1) {
    width: 4px;
    height: 14px;
    background: rgba(23, 117, 239, 1);
    border-radius: 2px;
    display: inline-block;
    margin-left: 20px;
  }
  > span:nth-child(2) {
    padding-left: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue